import type { Equipment } from 'shared';

/**
 * " · 3 de 20 livres" for a pooled equipment (quantidade > 1); empty for a
 * single unit, whose availability is already the badge.
 */
export function describeFreeUnits(eq: Pick<Equipment, 'quantidade' | 'emUso'>): string {
  const quantidade = eq.quantidade ?? 1;
  if (quantidade <= 1) return '';
  const free = Math.max(0, quantidade - (eq.emUso ?? 0));
  return ` · ${free} de ${quantidade} livres`;
}
